var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"tab",staticClass:"c-perk-tab"},[_c('PerkPointLabel')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }